module.exports = __webpack_public_path__ + "static/media/Splash_Bar_Backing@3x.9fe54562.png";